import React from "react";
import { Link } from "react-router-dom";
import { isLink, isStatus, getStatusRowStyle, formatLongRow } from "../../../../ui/helpers";

export function renderRegionsRow(headings, item) {
  return headings.map(([key]) => (
    <td
      key={key}
      className={`align-middle no-line border-0 px-5 py-5 ${isStatus(key) &&
        getStatusRowStyle(item)}`}
    >
      {isLink(key) ? (
        <Link className="text-dark" to={`/regions/${item.id}`}>
          {item[key]}
        </Link>
      ) : key === "definition" ? (
        formatLongRow(item[key], 70)
      ) : (
        item[key]
      )}
    </td>
  ));
}
